import { useQuery } from '@tanstack/react-query';
import { KTCard, KTCardBody } from '../../../../_metronic/helpers';
import { formatDate } from '../../../core/models/DateFormatter';
import {
  getVendorUpdates,
  VENDOR_UPDATE_TYPES,
  VendorUpdate,
  WorkOrderResource,
} from './vendorLink';

const VendorUpdateList = ({ updates }: { updates: VendorUpdate[] }) =>
  updates.length === 0 ? (
    <div className='text-muted'>No updates from the vendor yet.</div>
  ) : (
    <>
      {updates.map((u) => (
        <div key={u.id} className='border-bottom border-gray-200 py-3'>
          <div className='d-flex justify-content-between align-items-center'>
            <span className='badge badge-light-primary fs-7'>
              {VENDOR_UPDATE_TYPES[u.updateType] ?? 'Update'}
            </span>
            <span className='text-muted fs-7'>
              {/* CreatedOn is stored as UTC but serialized without a zone; mark it UTC so it shows in local time. */}
              {formatDate(
                u.createdOn.endsWith('Z') ? u.createdOn : `${u.createdOn}Z`,
                'dd MMM yyyy, hh:mm a'
              )}
            </span>
          </div>
          {u.notes && <div className='mt-2 text-gray-800'>{u.notes}</div>}
          {u.revisedDeliveryDate && (
            <div className='mt-1 fs-7 text-warning'>
              Revised delivery: {formatDate(u.revisedDeliveryDate, 'dd MMM yyyy')}
            </div>
          )}
        </div>
      ))}
    </>
  );

// Updates the vendor posted from the work order WhatsApp link.
const VendorUpdatesCard = ({ resource, id }: { resource: WorkOrderResource; id: number }) => {
  const { data = [] } = useQuery([`vendor-updates-${resource}-${id}`], () =>
    getVendorUpdates(resource, id)
  );

  return (
    <KTCard>
      <div className='card-header'>
        <div className='card-title'>
          <h3>Vendor Updates</h3>
        </div>
      </div>
      <KTCardBody>
        <VendorUpdateList updates={data} />
      </KTCardBody>
    </KTCard>
  );
};

export { VendorUpdatesCard, VendorUpdateList };
